import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminStudiesPage } from './admin-studies';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [
    AdminStudiesPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminStudiesPage),
    AgGridModule.withComponents([])
  ],
})
export class AdminStudiesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-studies/admin-studies.module.ts